module.exports = __webpack_public_path__ + "img/70.10.pH.75616353.png";